// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__12rzy","buttons":"RemoveExpirationActionButtons_buttons__1I2wV"};